<template>
  <div id="box">
    <div class="historyTag">
      <historyTag :historyArr="historyArr"></historyTag>
    </div>

    <el-alert
      type="info"
      :closable="false"
      show-icon
      style="margin-bottom: 12px"
      title="维护多个闲鱼/闲管家店铺账号（名称、闲鱼号、凭证）。类目/发货地/运费走全局配置；自动同步打到所有启用中的店铺。"
    />

    <div style="margin-bottom: 12px">
      <el-button type="primary" size="small" @click="openEdit()">新增店铺账号</el-button>
      <el-button size="small" :loading="loading" @click="fetchList">刷新</el-button>
    </div>

    <el-table :data="tableData" border v-loading="loading" style="width: 100%">
      <el-table-column prop="name" label="名称" min-width="120" />
      <el-table-column prop="userName" label="闲鱼号" min-width="140" show-overflow-tooltip />
      <el-table-column prop="appKey" label="appKey" min-width="140" show-overflow-tooltip />
      <el-table-column prop="appSecretMasked" label="appSecret" width="120" />
      <el-table-column label="状态" width="88" align="center">
        <template slot-scope="scope">
          <el-tag :type="scope.row.status === 1 ? 'success' : 'info'" size="mini">
            {{ scope.row.status === 1 ? "启用" : "停用" }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="remark" label="备注" min-width="120" show-overflow-tooltip />
      <el-table-column label="操作" width="200" align="center" fixed="right">
        <template slot-scope="scope">
          <el-button type="text" size="mini" @click="openEdit(scope.row)">编辑</el-button>
          <el-button type="text" size="mini" @click="toggleStatus(scope.row)">
            {{ scope.row.status === 1 ? "停用" : "启用" }}
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog :title="form.id ? '编辑闲鱼店铺' : '新增闲鱼店铺'" :visible.sync="editVisible" width="560px">
      <el-form :model="form" label-width="120px" size="small">
        <el-form-item label="名称" required>
          <el-input v-model.trim="form.name" maxlength="64" placeholder="后台展示名" />
        </el-form-item>
        <el-form-item label="闲鱼号" required>
          <el-input
            v-model.trim="form.userName"
            maxlength="128"
            placeholder="如 xy198097834419，注册后不可改"
            :disabled="!!form.id"
          />
        </el-form-item>
        <el-form-item label="appKey" required>
          <el-input v-model.trim="form.appKey" maxlength="64" />
        </el-form-item>
        <el-form-item :label="form.id ? 'appSecret' : 'appSecret'" :required="!form.id">
          <el-input
            v-model.trim="form.appSecret"
            maxlength="128"
            :placeholder="form.id ? '留空表示不修改' : '必填'"
            show-password
          />
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model.trim="form.remark" type="textarea" :rows="2" maxlength="255" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="editVisible = false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="submitSave">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "GoofishAccountList",
  data() {
    return {
      historyArr: ["系统管理", "闲鱼店铺账号"],
      loading: false,
      saving: false,
      tableData: [],
      editVisible: false,
      form: {
        id: null,
        name: "",
        userName: "",
        appKey: "",
        appSecret: "",
        remark: "",
        status: 1,
      },
    };
  },
  mounted() {
    this.fetchList();
  },
  methods: {
    fetchList() {
      this.loading = true;
      this.$https(this.$api.api.goofishAccountList, {}, "GET")
        .then((res) => {
          if (res.data && res.data.code == 200) {
            this.tableData = res.data.data || [];
          } else {
            this.tableData = [];
            this.$message.error((res.data && res.data.msg) || "加载失败");
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    openEdit(row) {
      if (row) {
        this.form = {
          id: row.id,
          name: row.name || "",
          userName: row.userName || "",
          appKey: row.appKey || "",
          appSecret: "",
          remark: row.remark || "",
          status: row.status,
        };
      } else {
        this.form = {
          id: null,
          name: "",
          userName: "",
          appKey: "",
          appSecret: "",
          remark: "",
          status: 1,
        };
      }
      this.editVisible = true;
    },
    submitSave() {
      if (!this.form.name || !this.form.userName || !this.form.appKey) {
        this.$message.warning("请填写名称、闲鱼号、appKey");
        return;
      }
      if (!this.form.id && !this.form.appSecret) {
        this.$message.warning("新建必须填写 appSecret");
        return;
      }
      const payload = { ...this.form };
      if (!payload.appSecret) delete payload.appSecret;
      this.saving = true;
      this.$https(this.$api.api.goofishAccountSave, payload, "POST")
        .then((res) => {
          if (res.data && res.data.code == 200) {
            this.$message.success(res.data.msg || "保存成功");
            this.editVisible = false;
            this.fetchList();
          } else {
            this.$message.error((res.data && res.data.msg) || "保存失败");
          }
        })
        .finally(() => {
          this.saving = false;
        });
    },
    toggleStatus(row) {
      const next = row.status === 1 ? 0 : 1;
      const tip = next === 1 ? "启用" : "停用";
      this.$confirm(`确认${tip}「${row.name}」？`, "提示", { type: "warning" })
        .then(() => {
          this.$https(this.$api.api.goofishAccountSetStatus, { id: row.id, status: next }, "POST").then((res) => {
            if (res.data && res.data.code == 200) {
              this.$message.success(res.data.msg || "已更新");
              this.fetchList();
            } else {
              this.$message.error((res.data && res.data.msg) || "操作失败");
            }
          });
        })
        .catch(() => {});
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/goofish/account/index.vue